import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from "reactstrap"
import { Route, Routes } from 'react-router-dom'
import AutomatelyListHeader from "./AutomatelyListHeader"
import AutomationList from "./AutomationList"
import WorkflowBuilder from "./WorkflowBuilder/WorkflowBuilder"
import HistoryTab from "./WorkflowBuilder/HistoryTab"
import "./Automately.css"

const AUTOMATION_FILTERS_STORAGE_KEY = 'AutomationContainerFilters'
const DEFAULT_AUTOMATION_FILTERS = { searchTerm: '' }

const getInitialAutomationFilters = () => {
    try {
        const savedFilters = localStorage.getItem(AUTOMATION_FILTERS_STORAGE_KEY)
        const parsedFilters = savedFilters ? JSON.parse(savedFilters) : null
        return parsedFilters && typeof parsedFilters === 'object' && !Array.isArray(parsedFilters)
            ? parsedFilters
            : DEFAULT_AUTOMATION_FILTERS
    } catch {
        return DEFAULT_AUTOMATION_FILTERS
    }
}

export default function AutomatelyContainer() {
    return (
        <div className="AutomatelyContainer">
            <Routes>
                <Route path="/new" element={<WorkflowBuilder />} />
                <Route path="/:id" element={<WorkflowBuilder />} />
                <Route path="/" element={<AutomationWorkspace />} />
            </Routes>
        </div>
    )
}

const AutomationWorkspace = () => {
    const [activeTab, setActiveTab] = useState(() => (
        window.location.hash === '#execution-logs' ? 'execution-logs' : 'automations'
    ))
    const [filterValues, setFilterValues] = useState(getInitialAutomationFilters)

    useEffect(() => {
        try {
            localStorage.setItem(AUTOMATION_FILTERS_STORAGE_KEY, JSON.stringify(filterValues))
        } catch { /* Keep filters in memory when browser storage is unavailable. */ }
    }, [filterValues])

    useEffect(() => {
        const syncTabWithFragment = () => {
            const requestedTab = window.location.hash.replace('#', '')
            const nextTab = requestedTab === 'execution-logs' ? 'execution-logs' : 'automations'
            setActiveTab(nextTab)

            if (window.location.hash !== `#${nextTab}`) {
                window.history.replaceState(
                    null,
                    '',
                    `${window.location.pathname}${window.location.search}#${nextTab}`
                )
            }
        }

        syncTabWithFragment()
        window.addEventListener('hashchange', syncTabWithFragment)
        return () => window.removeEventListener('hashchange', syncTabWithFragment)
    }, [])

    const handleTabChange = (tab) => {
        setActiveTab(tab)
        if (window.location.hash !== `#${tab}`) window.location.hash = tab
    }

    return (
        <Container fluid className="automately-list-page">
            <AutomatelyListHeader
                activeTab={activeTab}
                onTabChange={handleTabChange}
                filterValues={filterValues}
                setFilterValues={setFilterValues}
            />
            <Row className="automately-list-row">
                <Col>
                    {activeTab === 'automations' ? (
                        <AutomationList {...filterValues} />
                    ) : (
                        <HistoryTab showAutomation embedded />
                    )}
                </Col>
            </Row>
        </Container>
    )
}
